export class DocumentCollaborationParameter {
  public problemNo: string;
  public orderUserCode: string;

  hasValue(): boolean {
    return !!this.problemNo || !!this.orderUserCode;
  }  
}
